const myTestRoutes = [
    {
        path:'index',
        name:'myTest-index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/myTest/index.vue')
    },
    {
        path:'cogMate',
        name:'myTest-cogMate',
        component: () => import(/* webpackChunkName: "about" */ '@/views/myTest/cogMateView.vue')
    }
  ]
  export default myTestRoutes